import { useSelector } from "../store/store";
import { useCallback } from "react";

const users = [
  "thiennv@viags.vn",
  "namdh@viags.vn",
  "trungdt@viags.vn",
  "hieppt@viags.vn",
  "botit@viags.vn",
  "tienhc@viags.vn",
  "huyth@viags.vn",
  "datnt@viags.vn",
  "sonnhong@viags.vn",
  "taidv@viags.vn",
  "thuonghh@viags.vn",
  "luubd@viags.vn",
  "nghitc@viags.vn",
  "phuocvd@viags.vn",
];

export const useUser = () => {
  const user = useSelector((state) => state.user);
  const currentUserEmail: string = user?.current?.username;
  const currentUserName: string = user?.current?.name;
  const currentUserId: string = user?.current?.localAccountId;

  const userAdmin = useSelector((state) => state.userAdmin);
  const isThienNV = user?.current?.username?.toLowerCase() === "thiennv@viags.vn";

  const checkCurrentUser = useCallback(
    (email: string) => {
      if (!email || typeof email !== "string") return false;
      return currentUserEmail.toLowerCase() === email.toLowerCase();
    },
    [currentUserEmail],
  );

  const isHighPriority = useCallback(
    (highPriorityUsers: string[] = users) => {
      return highPriorityUsers.includes(currentUserName.toLowerCase());
    },
    [currentUserName],
  );

  return {
    checkCurrentUser,
    user,
    email: currentUserEmail,
    name: currentUserName,
    id: currentUserId,
    isHighPriority,
    userAdmin,
    isThienNV,
  };
};
